<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">TBA Participations</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">
        Dashboard
      </router-link>
      /

      <router-link to="/change-forms">
        Change Forms
      </router-link>
      /
      <b>Request</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title mb-3">Request Change Form</h4>
            <p>Fill in the form to below to request a change form</p>

            <b><label for="">Project</label></b>
            <div class="form-group">
              <input
                type="text"
                v-model="change.project"
                class="form-control"
                disabled
              />
              <!-- <select name="" id="" class="form-control" v-model="change.project">
              <option value="Takaful Mobile App" selected="selected">Takaful Mobile App</option>
              <option value="TBA Call Centre">TBA Call Centre</option>
            </select> -->
            </div>

            <b><label for="">Description</label></b>
            <div class="form-group">
              <textarea
                name=""
                id=""
                cols="30"
                rows="2"
                class="form-control"
                placeholder="Please include customer's name and field to be changed before and after values"
                v-model="change.description"
              ></textarea>
            </div>

            <b><label for="">Approved By</label></b>
            <div class="form-group">
              <input
                type="text"
                name=""
                id=""
                class="form-control"
                v-model="change.approved_by"
              />
            </div>

            <b><label for="">Additional Emails To Be CC</label></b>
            <div class="form-group">
              <textarea
                name=""
                id=""
                cols="30"
                rows="1"
                class="form-control"
                placeholder="example@email.com,example2@email.com"
                v-model="change.additional_emails"
              ></textarea>
              <small
                >Please include the emails you want us to send an email when we
                completed the change form, separated by comma.</small
              >
              <small
                >Suzannie's and Haji Fawzy's emails are already included</small
              >
            </div>

            <div class="form-group">
              <button class="btn btn-success" @click="submitRequest">
                Submit Request
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";

export default {
  name: "change_form_request",
  data() {
    return {
      change: {
        project: "Takaful Mobile App",
        description: "",
        approved_by: "",
        additional_emails: ""
      }
    };
  },

  methods: {
    // load all purchases to save axios from keep making multiple queries in one page

    submitRequest() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;
        swal({
          icon: "warning",
          text: "Are you sure?",
          buttons: ["Cancel", "Yes"]
        }).then(confirm => {
          if (confirm) {
            axios
              .post(
                "/change_form",
                {
                  project: this.change.project,
                  description: this.change.description,
                  approved_by: this.change.approved_by,
                  additional_emails: this.change.additional_emails
                },
                {
                  headers: {
                    Authorization: "Bearer " + token
                  }
                }
              )
              .then(res => {
                if (res.data.authorised === false) {
                  swal({
                    icon: "error",
                    text: "Not authorised"
                  });
                } else {
                  if (res.data.success === true) {
                    swal({
                      icon: "success",
                      text: res.data.message
                    }).then(ok => {
                      this.$router.push("change-forms");
                    });
                  } else {
                    swal({
                      icon: "error",
                      text: res.data.message
                    });
                  }
                }
              })
              .catch(res => {
                swal({
                  icon: "error",
                  text: "An error occured, please contact Nextacloud"
                });
              });
          } else {
            swal({
              icon: "info",
              text: "Cancelled"
            });
          }
        });
      }
    }
  },

  mounted() {}
};
</script>
